<template>
    <div class="row mt-5">
        <div class="col-lg-12 col-md-12 d-flex justify-content-between">
            <div v-on:click="clicked(0,0,null)" class="tab-button curriculum" v-bind:class="{ activeTab: (selectedTab == 0) }">
                <span>Course Information</span>
            </div>
            <div v-on:click="clicked(5,0,null)" class="tab-button curriculum" v-bind:class="{ activeTab: (selectedTab == 5) }">
                <span class="inner">Course Features</span>
            </div>
            <div v-on:click="clicked(4,0,0)" class="tab-button curriculum" v-bind:class="{ activeTab: (selectedTab == 4) }">
                <span>Course Content</span>
            </div>
            <div v-on:click="clicked(1,0,null)" class="tab-button curriculum" v-bind:class="{ activeTab: (selectedTab == 1) }">
                <span>Certificate</span>
            </div>
            <div v-on:click="clicked(2,0,null)" class="tab-button curriculum" v-bind:class="{ activeTab: (selectedTab == 2) }">
                <span class="inner">Students</span>
            </div>
            <div v-if="course && course.isFacilitated" v-on:click="clicked(6,0,null)" class="tab-button curriculum" v-bind:class="{ activeTab: (selectedTab == 6) }">
                <span class="inner">Attendees</span>
            </div>
            <div v-on:click="clicked(3,0,null)" class="tab-button curriculum" v-bind:class="{ activeTab: (selectedTab == 3) }">
                <span class="inner">Coupons</span>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'CourseActions',
        props: ["initialCourse", "edit", "tab"],
        data: function () {
            return {
                course: this.initialCourse,
                editEnabled: this.edit,
                selectedTab: this.tab,
            };
        },
        watch: {
            edit: function(newVal, oldVal){
                this.editEnabled = newVal;
            },
            tab: function(newVal, oldVal){
                this.selectedTab = newVal;
            },
            initialCourse: function(newVal, oldVal){
                this.course = newVal;
            },

        },
        methods: {
            clicked(tabIndex, page, chapter) {
                this.selectedTab = tabIndex;
                this.$emit("tabClick",tabIndex, page, chapter);
            },
        },
        mounted: function () {
            //console.log("Course actions loaded", this.course, this.editEnabled);
        },
    }
</script>

<style scoped>
    .btn-primary {
        border-radius: 8px 8px 0 0;
        background-color: #282d69;
        color: white;
        right: 0;
        border: 1px solid #282d69;
        border-bottom: none;
    }

        .btn-primary:hover {
            background-color: white !important;
            color: #282d69 !important;
            border: 1px solid #282d69 !important;
            border-bottom: none !important;
        }

    .btn-secondary {
        border-radius: 8px 8px 0 0;
        background-color: white !important;
        color: black;
        right: 0;
        border: 1px solid #282d69;
        border-bottom: none;
    }

        .btn-secondary:hover {
            background-color: white !important;
            color: #282D69 !important;
            border: 1px solid #282d69;
            border-bottom: none;
            box-shadow: #282d69 1px 1px 5px 1px;
        }


    .tab-button {
        border-radius: 8px 8px 0 0;
        border: 1px solid black;
        border-bottom: none;
        background-color: #3d3c79;
        color: white;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
        width: 100%;
        padding: 10px;
        margin: 0 5px;
        display: flex;
        justify-content: center;
        align-items: center;
    }


    .tab-button:hover {
        background-color: white;
        color: #3d3c79;
        cursor: pointer;
        box-shadow: #3d3c79 1px 1px 5px 1px
    }

    .activeTab {
        background-color: white !important;
        color: #3d3c79;
        border: 1px solid #3d3c79 !important;
        border-bottom: none !important;
    }

        .activeTab:hover {
            background-color: white !important;
            color: #3d3c79;
            border: 1px solid #3d3c79 !important;
            border-bottom: none !important;
            box-shadow: none;
            cursor: default;
        }
</style>
